/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.221.0-v202611032344-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqSubscriptionsApiClass {
 
   constructor() {}

  /**
   * @summary List channels and their subscriptions
   * @param {number} [offset=0] - The pagination offset, the index of the first subscription that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of subscriptions that will be returned in this page of results
  */
  public getChannels(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/subscriptions`;
    const urlTemplate = `${baseUrl}/subscriptions`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.GetChannelsOutputV1>;
  }

  /**
   * @summary Subscribe to websocket messages published to the specified channel
  */
  public subscribe(
    body: models.SubscriptionInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/subscriptions`;
    const urlTemplate = `${baseUrl}/subscriptions`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Unsubscribe from the specified channel
   * @param {string} channelId - URI that identifies the channel to delete
  */
  public unsubscribe(
    {
      channelId
    } : {
      channelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (channelId === null || channelId === undefined) {
      throw new Error("'channelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/subscriptions/${encodeURIComponent(String(channelId))}`
      .replace('{channelId}', encodeURIComponent(String(channelId)));
    const urlTemplate = `${baseUrl}/subscriptions/{channelId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Update a subscription associated with the specified channel
   * @param {string} channelId - URI that identifies the channel the subscriber is updating
  */
  public updateSubscription(
    body: models.SubscriptionUpdateInputV1,
    {
      channelId
    } : {
      channelId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (channelId === null || channelId === undefined) {
      throw new Error("'channelId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/subscriptions/${encodeURIComponent(String(channelId))}`
      .replace('{channelId}', encodeURIComponent(String(channelId)));
    const urlTemplate = `${baseUrl}/subscriptions/{channelId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

}


export const sqSubscriptionsApi = new sqSubscriptionsApiClass();

export type sqSubscriptionsApiEndpoints = {
  'getChannels': {
    method: 'get';
    path: '/subscriptions';
    response: models.GetChannelsOutputV1;
  };
  'subscribe': {
    method: 'post';
    path: '/subscriptions';
    response: models.StatusMessageBase;
  };
  'unsubscribe': {
    method: 'delete';
    path: '/subscriptions/${encodeURIComponent(String(channelId))}';
    response: models.StatusMessageBase;
  };
  'updateSubscription': {
    method: 'post';
    path: '/subscriptions/${encodeURIComponent(String(channelId))}';
    response: models.StatusMessageBase;
  };
};

type ApiGetChannelsResponse = models.GetChannelsOutputV1;
export function GetChannelsQueryKey(
  params: Parameters<typeof sqSubscriptionsApi.getChannels>[0],
) {
  return ['sqSubscriptionsApi', 'getChannels', params] as const;
}

export function useApiGetChannelsQuery(
  params: Parameters<typeof sqSubscriptionsApi.getChannels>[0],
  options?: Omit<UseQueryOptions<ApiGetChannelsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetChannelsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetChannelsQueryKey(params),
    queryFn: () =>
      sqSubscriptionsApi.getChannels(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSubscribeResponse = models.StatusMessageBase;
type ApisubscribeMutationParams = Parameters<typeof sqSubscriptionsApi.subscribe> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSubscriptionsApi.subscribe>;
type ApisubscribeMutationVariables = models.SubscriptionInputV1;

export function useApiSubscribeMutation(
  options?: Omit<UseMutationOptions<ApiSubscribeResponse, AxiosError<SeeqErrorData>,
    ApisubscribeMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSubscribeResponse, AxiosError<SeeqErrorData>,
  ApisubscribeMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApisubscribeMutationVariables) =>
      sqSubscriptionsApi.subscribe(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUnsubscribeResponse = models.StatusMessageBase;
type ApiunsubscribeMutationParams = Parameters<typeof sqSubscriptionsApi.unsubscribe> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSubscriptionsApi.unsubscribe>;

export function useApiUnsubscribeMutation(
  options?: Omit<UseMutationOptions<ApiUnsubscribeResponse, AxiosError<SeeqErrorData>,
    ApiunsubscribeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUnsubscribeResponse, AxiosError<SeeqErrorData>,
  ApiunsubscribeMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiunsubscribeMutationParams) =>
      sqSubscriptionsApi.unsubscribe(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateSubscriptionResponse = models.StatusMessageBase;
type ApiupdateSubscriptionMutationParams = Parameters<typeof sqSubscriptionsApi.updateSubscription> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqSubscriptionsApi.updateSubscription>;

export function useApiUpdateSubscriptionMutation(
  options?: Omit<UseMutationOptions<ApiUpdateSubscriptionResponse, AxiosError<SeeqErrorData>,
    ApiupdateSubscriptionMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiUpdateSubscriptionResponse, AxiosError<SeeqErrorData>,
  ApiupdateSubscriptionMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApiupdateSubscriptionMutationParams) =>
      sqSubscriptionsApi.updateSubscription(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
